<template>
  <v-container
    fill-height
    fluid
    class="screenBackground"
    style="
      max-height: 100%;
      max-width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      align-items: start;
      padding: 0%;
    "
  >
    <v-row style="height: 100%" no-gutters>
      <v-col cols="6" no-gutters>
        <div style="height: 50%; background-color: transparent; padding: 10px">
          <ResultsTable />
        </div>
        <div style="height: 50%; background-color: transparent; padding: 10px">
          <ResultsCharts ref="resultsCharts" />
        </div>
      </v-col>
      <v-col cols="6" no-gutters>
        <div style="height: 100%; background-color: transparent; padding: 10px">
          <DualChartContainer
            ref="dualChartContainer"
            :topChartOptions="kDiagramPowerChartOptions"
            :bottomChartOptions="kDiagramSpeedChartOptions"
          >
            <template #header>
              <h3 class="chart-title">K-Diagram</h3>
            </template>
          </DualChartContainer>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
const companyId = process.env.VUE_APP_COMPANY_ID
const ResultsTable = (companyId === "5" || companyId === "4")
  ? require("../components/ResultsTable_SeaPioneer.vue").default
  : require("../components/ResultsTable.vue").default
import ResultsCharts from "../components/ResultsCharts.vue";
import DualChartContainer from "../components/DualChartContainer.vue";
export default {
  name: "KDiagramCalculationSuccessViewLarge",
  components: {
    ResultsTable,
    ResultsCharts,
    DualChartContainer,
  },
  data: function () {
    return {
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("kDiagram", ["calculationFailed"]),
    ...mapGetters("kDiagram", [
      "kDiagramPowerChartOptions",
      "kDiagramSpeedChartOptions",
    ]),
  },
  methods: {
    reflowCharts() {
      if (!this.$refs.dualChartContainer || !this.$refs.resultsCharts) {
        return;
      }
      const powerChart = this.$refs.dualChartContainer.$children[0].chart;
      const speedChart = this.$refs.dualChartContainer.$children[1].chart;
      const resultsCharts =
        this.$refs.resultsCharts.$children[0].$children[1].chart;

      if (powerChart) {
        powerChart.reflow();
      }
      if (speedChart) {
        speedChart.reflow();
      }
      if (resultsCharts) {
        resultsCharts.reflow();
      }
    },
  },
  watch: {
    calculationFailed: {
      handler(value) {
        if (value) {
          this.showErrorSnackBar = true;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.chart-title {
  font-weight: 300;
  color: var(--color-text);
}
</style>
